import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./ga4";

export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const lastSent = useRef(null);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (lastSent.current === key) return;
    lastSent.current = key;
    const t = setTimeout(
      () => trackPageView({ pathname: location.pathname, search: location.search }),
      200
    );
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
